<script setup>
import StormTrack from '@/components/StormTrack.vue';

</script>

<template>
  <Suspense>
    <StormTrack />
  </Suspense>
</template>
